import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { IDbConfigResponse, PatentDbApi } from '../patent-db-api';

@injectable()
export class PatentApiImpl extends PsHttpService implements PatentDbApi {
    get options() {
        return {
            baseURL: import.meta.env.VITE_CORE_BASIC_SERVICE_URI,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    /**
     * 获取专利数据库配置
     */
    async getDbConfig() {
        const res = await this.get<PatSnapSuccessResponseData<IDbConfigResponse>>({
            url: '/core-basic-api/analytics/db-select/config',
            cache: true,
        });
        return res.data;
    }
}
